import useTranslation from "next-translate/useTranslation";
import nookies from "nookies";
import { useEffect, useLayoutEffect, useRef } from "react";

import { useSelector } from "react-redux";
import { selectors as CreditDemandeSelectors } from "redux/slices/v2/DemandeUnCredit";
import formatUrl from "utils/FormatUrl";
import DemandCredit from "../../page/DemanderUnCredit/DemandCredit";
import $ from "utils/selectors";
const buildUrl = (activeStep, lang) => {
  if (activeStep) {
    return formatUrl(
      `/credit-immobilier/demander-un-credit${
        activeStep == 1
          ? ""
          : activeStep == 2
          ? "/projet"
          : activeStep == 3
          ? "/budget"
          : activeStep == 4
          ? "/form"
          : activeStep == 5
          ? "/demande"
          : ""
      }`,
      lang
    );
  }
};

export default function DemandeUnCreditPagesHepler({ data }) {
  const activeStep = useSelector(CreditDemandeSelectors.activeStepSelector);
  const { lang } = useTranslation("");
  useEffect(() => {
    $("body").css("height", "100%");
    // const analytics = getAnalytics(app);
    let url = buildUrl(activeStep, lang);
    // if (process.env.NEXT_PUBLIC_DATADOG_ENABLED) {
  }, []);
  const firstUpdateSP = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdateSP.current) {
      firstUpdateSP.current = false;
      return;
    } else {
      // const analytics = getAnalytics(app);
      let url = buildUrl(activeStep, lang);
      // if (process.env.NEXT_PUBLIC_DATADOG_ENABLED) {

      window.history.pushState({}, "", url);
    }
  }, [activeStep]);

  return (
    <>
      <DemandCredit data={data} />
    </>
  );
}

export const getServerSideProps = () => {
  return async (ctx) => {
    let props: any = {};
    try {
      props = await getServerSideHelper(ctx, 1);
    } catch (e) {}
    return props;
  };
};

export const getServerSideHelper = async (ctx: any, activeStep: any) => {
  const cookies = nookies.get(ctx);
  const accessToken = cookies.AccessToken;

  return new Promise(async (resolve, reject) => {
    if (activeStep < 6) {
      if (activeStep == 1) {
        resolve({});
      } else {
        resolve({
          redirect: {
            destination: `/credit-immobilier/demander-un-credit`,
            permanent: true,
          },
        });
      }
    }
  });
};
